import React from "react";


import StationChart from "../AnalysisComp/AnalysisComp";

export default function StationChartEnergyActive() {


 

  return (
    <StationChart measurand='Energy.Active.Import.Register' chartType="bar" label="Energy Active (kWh)"
      unit="kwh"     convert={(v) => Number((v*.001).toFixed(2))}/>
  )

}
